import SingleMatterSync from './SingleMatterSync';
import SingleMatterSyncInline from './SingleMatterSyncInline';

export default SingleMatterSync;
export { SingleMatterSyncInline };
export {
  SingleMatterSyncProvider,
  useSingleMatterSync,
} from './SingleMatterSyncProvider';
